export const required = {
  hasFeedback: true,
  rules: [
    {
      required: true,
    },
  ],
};
